import { AuthenticationService } from './../../servicios/authentication.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  CertificadoNoAdeudo,
  AuxJasper,
  ParametroJasper, Cargos, Privilegios
} from "../../entidades/entidades";
import { Cortes, CatSucursales, ObtenerUsuarioPorCargoInput } from '../../entidades/entidades';
import { CortesService } from "../../servicios/cortes.service";
import { ObtenerUsuarioPorCargoService } from "../../servicios/obtener-usuario-por-cargo.service";
import { CatSucursalService } from "../../servicios/cat-sucursal.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { ObtenerUsuarioPorCargo, CatUsuarios, CorteTotal} from '../../entidades/entidades';
import { truncateSync } from "fs";
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
import { CatNivelSeguridadesService } from 'app/servicios/cat-nivel-seguridades.service';
import { SelectItem } from 'primeng/api';
import { CorteTotalService } from '../../servicios/corte-total.service'
import { PrivilegiosService } from 'app/servicios/privilegios.service';
import { CatBancosService } from '../../servicios/cat-bancos.service';

declare var $: any;

@Component({
  selector: "app-admin-caja",
  templateUrl: "./admin-caja.component.html",
  styleUrls: ["./admin-caja.component.css"],
})


export class AdminCajaComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  admin_caja: FormGroup;
  auxJasper: AuxJasper;
  auxJasperTotalesMediosPagos: AuxJasper;
  auxJasperDetallesMediosPagos: AuxJasper;
  auxJasperCobroDetallesCajeros: AuxJasper;
  auxJasperCobrosDetalles: AuxJasper;
  auxJasperCobros: AuxJasper;
 auxJasperCierreCaja: AuxJasper;
 auxJasperResumenIngresos: AuxJasper;
 auxJasperResumenCuenta: AuxJasper;
 auxJasperGlobalDetallado: AuxJasper;
  buscando: boolean = false;
  excel: boolean = false;
  privilegiosDrops: boolean = false;
  filters: any;

  auxJasperPorSucursales: AuxJasper;
  auxJasperEstadoMovimientos: AuxJasper;
  auxJasperConceptosPagados: AuxJasper;
  auxJasperDesgloceConceptos: AuxJasper;
  auxJasperPagosCancelados: AuxJasper;

  auxJasperExcel: AuxJasper;

  cortes: Cortes;
  usuarios: ObtenerUsuarioPorCargo;
  public usuarioActual: ObtenerUsuarioPorCargo[] = [];
  public catSucursal: CatSucursales;
  public catSucursalActual: CatSucursales[] = [];
  public usuarioSimple: CatUsuarios;

  public catSucursales: SelectItem[];
  public cSucursal: CatSucursales;

  public catUsuarios: SelectItem[];
  public catUsuariosActual: SelectItem[];
  public cUsuarios: CatUsuarios = null;

  public catBancos: SelectItem[];

  usuario: any;
  idUsuarioCajero: number;
  sucursal: any;

  idCorte: number;

  //para extraer los valores de sucursal
  // catSucursales: any[] = [];
  selectedSucursal: any;
  selectedUsuario: any;
  selectedBank: any;
  resultadosCorteTotal: CorteTotal[];
  // admin_caja: FormGroup;


  cajaAgua: boolean = false;
  cierraCaja: boolean = false;
  cerrarCaja: boolean = true;

  //      OPCIONES DEL MENÚ
  cobrosAgua: boolean = false;
  mediosPago: boolean = false;
  detallemMediosPago: boolean = false;
  cobrosConcepto: boolean = false;
  cobrosDetalle: boolean = false;
  resumenMovimeintos: boolean = false;
  conceptoIVA: boolean = false;

  porSucursales: boolean = false;
  estadoMovimientos: boolean = false;
  conceptosPagados: boolean = false;
  pagosCancelados: boolean = false;
  globalDetallado: boolean = false;
  currentRoute: string;

  public progressBar = false;

  public jasperInputExcel$ = new EventEmitter<AuxJasper>();

  public jasperInput$ = new EventEmitter<AuxJasper>();
  public jasperInputExporta$ = new EventEmitter<AuxJasper>();
  public jasperInputMediosTotales$ = new EventEmitter<AuxJasper>();
  public jasperInputMediosDetalles$ = new EventEmitter<AuxJasper>();
  public jasperInputCobroDetalleCajero$ = new EventEmitter<AuxJasper>();
  public jasperInputCobrosDetalles$ = new EventEmitter<AuxJasper>();
  public jasperInputCobrosDetalles2$ = new EventEmitter<AuxJasper>();
  public jasperInputCierreCaja$ = new EventEmitter<AuxJasper>();
  public jasperInputResumenIngresos$ = new EventEmitter<AuxJasper>();
  public jasperInputResumenCuenta$ = new EventEmitter<AuxJasper>();

  public jasperInputPorSucursales$ = new EventEmitter<AuxJasper>();
  public jasperInputEstadoMovimientos$ = new EventEmitter<AuxJasper>();
  public jasperInputConceptosPagados$ = new EventEmitter<AuxJasper>();
  public jasperInputDesgloceConceptos$ = new EventEmitter<AuxJasper>();
  public jasperInputPagosCancelados$ = new EventEmitter<AuxJasper>();
  public jasperInputGlobalDetallado$ = new EventEmitter<AuxJasper>();

  public idNivel;
  //@Output("jasperOutput") jasperOutput: EventEmitter<AuxJasper>;

  display: boolean = false;
  showDialog() {
    this.display = true;
  }

  fecha: any;

  @Input("cobros_detalle") cobros_detalle: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private cortesService: CortesService,
    private catUsuariosService: ObtenerUsuarioPorCargoService,
    private catSucursalService: CatSucursalService,
    private catUsuariosS: CatUsuariosService,
    private privilegiosService: PrivilegiosService,
    private authenticationService: AuthenticationService,
    private catNivelSeguridadesService: CatNivelSeguridadesService,
    private corteTotalService: CorteTotalService,
    private route: ActivatedRoute,
    private catBancosService: CatBancosService
  ) { }

  async ngOnInit() {
    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue;

    //Obtenemos el nivel del privilegio.
    let objUrl = new Privilegios();
    objUrl.descripcion = this.router.url;
    var objNivelSeg = await this.catNivelSeguridadesService
      .GetNivelPorPrivilegio(objUrl)
      .toPromise();
    if (objNivelSeg[0] != undefined) {
      this.idNivel = objNivelSeg[0].id;
    }

    let cortes = new Cortes();
    cortes.idUsuarioCajero = this.usuario.id;
    this.getCortes(cortes);
    
    this.admin_caja = this.formBuilder.group({
      nombre: [undefined],
      fecha_apertura: [undefined],
      fecha_cierre: [undefined],
      sucursal: [null],
      idUsuarioCajero: [null],
      idSucursal: [null],
      idBanco: [null]
    });

    const now = new Date();
    const fechaActual = now.toISOString().slice(0, 10); // Obtiene el formato "YYYY-MM-DD"
    
    this.fecha = fechaActual;
    
    this.admin_caja.patchValue({
      fecha_apertura: fechaActual,
      fecha_cierre: fechaActual,
    });
    

    this.jasperInput$.emit(null);
    await this.getCatUsuarios(this.usuario.id);
    await this.getPrivilegios();
    await this.getCatBancos();

    this.route.url.subscribe((url) => {
      this.currentRoute = this.router.url;

      if(this.currentRoute === '/ingresos/admin-caja'){
        this.porSucursales = true;
      }
    });
  }

  async getCatUsuarios(id: number) {
    try {
      this.progressBar = true;
      let parametros = new ObtenerUsuarioPorCargoInput();
      let datoRetorno = await this.catUsuariosService
        .getBusquedas(parametros)
        .toPromise();


      this.catUsuarios = datoRetorno.map((datos) => {
        return { label: datos.nombreUsuario, value: datos.id };
      });

      this.catUsuarios.unshift({
        label: "Todos", value: null
      });


       // Si el id es null, significa que "Todos" fue seleccionado
    if (id === null) {
      this.usuarios = null;
      this.catUsuariosActual = [
        { label: "Todos", value: null }
      ];

      await this.admin_caja.patchValue({
        idUsuarioCajero: null,
      });

      // Manejo especial si necesitas hacer algo adicional cuando "Todos" es seleccionado
      await this.getSucursal(null);
    } else {
//hasta aqui llega el codigo
      this.usuarios = datoRetorno.find((x) => x.id === id);

      this.catUsuariosActual = [
        { label: this.usuarios.nombreUsuario, value: this.usuarios.id }
      ];


      await this.admin_caja.patchValue({
        idUsuarioCajero: this.usuarios.id,
      });

      await this.getSucursal(this.usuarios.idSucursal);
      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUsuarios");
      this.progressBar = false;
    }
  }


  async getCortes(Cortes: Cortes) {
    try {
      var datoRetorno = await this.cortesService
        .getBusquedas(Cortes)
        .toPromise();

      this.cortes = datoRetorno;

      let date: Date = new Date();

      //this.cortes.fechaCierre = date;
      this.idCorte = datoRetorno.id;

      if (this.idCorte == 0) {
        this.cortes = datoRetorno;
        this.cerrarCaja = false;
      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCortes");
    }
  }

  async cierraCorte() {
    try {
      if (this.idCorte == 0) {
        this.cerrarCaja = false;
      } else {
        this.cerrarCaja = true;

        const datoRetorno = await this.cortesService
          .update(this.cortes)
          .toPromise();
        this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
        this.cerrarCaja = false;
      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCortes");
    }
  }

  async exportar() {
    try {
      this.excel = true;
      let reportes = this.admin_caja.value;


      let Usuario = new ParametroJasper();
      let Apertura = new ParametroJasper();
      let Cierre = new ParametroJasper();
      let DetallesSuc = new ParametroJasper();
      let ResumenIngresos = new ParametroJasper();
      let Formato = new ParametroJasper();
      let usuarioEmite = new ParametroJasper();
      let banco = new ParametroJasper();

      if (reportes.idUsuarioCajero) {
        Usuario.nombre = "_id_usuario";
        // Usuario.valor = this.usuarios.id + "";
        if (this.cobros_detalle) {
          Usuario.valor = null;
        } else {
          // Usuario.valor = reportes.idUsuarioCajero + "";
          Usuario.valor = reportes.idUsuarioCajero ? reportes.idUsuarioCajero.toString() : null;

        }
      }

      Apertura.nombre = "_fecha_de";
      Apertura.valor = reportes.fecha_apertura + "";
      Cierre.nombre = "_fecha_hasta";
      Cierre.valor = reportes.fecha_cierre + "";
      
      

      if (reportes.idSucursal) {
        DetallesSuc.nombre = "_id_sucursal";
        if (this.cobros_detalle) {
          DetallesSuc.valor = null;
        } else {
          // DetallesSuc.valor = reportes.idSucursal + "";
          DetallesSuc.valor = reportes.idSucursal ? reportes.idSucursal.toString() : null;

        } 
      }

      Formato.nombre = "_formato";
      Formato.valor = "xlsx";
      usuarioEmite.nombre = '_usuario';
      usuarioEmite.valor = this.usuario.id + '';
 
      this.auxJasper = new AuxJasper();
      //boton de expotar para cada reporte
      if(this.currentRoute === '/ingresos/admin-caja'){
        if (this.selectedUsuario !== undefined && this.selectedUsuario !== null) {
          Usuario.nombre = '_id_usuario';
          Usuario.valor = this.selectedUsuario.value !== null ? this.selectedUsuario.value + "" : null;
        } else {
          Usuario.nombre = '_id_usuario';
          Usuario.valor = null;
        }
        if (this.selectedSucursal !== undefined && this.selectedSucursal !== null) {
          DetallesSuc.nombre = 'sucursal';
          DetallesSuc.valor = this.selectedSucursal.value !== null ? this.selectedSucursal.value + "" : null;
        } else {
          DetallesSuc.nombre = 'sucursal';
          DetallesSuc.valor = null;
        }
        if (this.selectedBank !== undefined && this.selectedBank !== null) {
          banco.nombre = '_id_banco';
          banco.valor = this.selectedBank.value !== null ? this.selectedBank.value + "" : null;
        } else {
          banco.nombre = '_id_banco';
          banco.valor = null;
        }
        if (this.porSucursales == true) {      
          this.auxJasper.JasperReport.nombreReporte = "ResumenPorSucursal";
        }
        if (this.estadoMovimientos == true) {
          this.auxJasper.JasperReport.nombreReporte = "EstadoMovimientos";
        }
        if (this.conceptosPagados == true) {
          this.auxJasper.JasperReport.nombreReporte = "018_Conceptos_Pagados";
        }
        if (this.pagosCancelados == true) {
          this.auxJasper.JasperReport.nombreReporte = "033_pagos_cancelados";
        }
        if(this.globalDetallado == true){
          this.auxJasper.JasperReport.nombreReporte = "047_Reporte_Global_Ingresos";
        }
      }else{
        if (this.cobrosAgua == true) {
          this.auxJasper.JasperReport.nombreReporte = "004_ReportePorConceptos";
        }
        if (this.mediosPago == true) {
          this.auxJasper.JasperReport.nombreReporte = "005_MediosPagos";
        }
        if (this.detallemMediosPago == true) {
          this.auxJasper.JasperReport.nombreReporte = "006_DetallesMediosPagos";
        }
        if (this.cobrosConcepto == true) {
          this.auxJasper.JasperReport.nombreReporte = "004_cobrosDetalleCajero";
        }
        if (this.cierraCaja == true) {
          this.auxJasper.JasperReport.nombreReporte = "005_CierreCaja";
        }
        if (this.cobrosDetalle == true) {
          this.auxJasper.JasperReport.nombreReporte = "004_cobrosDetalles";
        }
        if (this.resumenMovimeintos == true) {
          this.auxJasper.JasperReport.nombreReporte = "011_Detalle_General";
        }
        if (this.cobros_detalle) {
          if (this.conceptoIVA) {
            this.auxJasper.JasperReport.nombreReporte = "013_Concepto_IVA";
          }
        }
      }
      
      this.auxJasper.JasperReport.tipo = "xlsx";

      await this.auxJasper.ParametroJasper.push(Usuario);
      await this.auxJasper.ParametroJasper.push(Apertura);
      await this.auxJasper.ParametroJasper.push(Cierre);
      await this.auxJasper.ParametroJasper.push(DetallesSuc);
      await this.auxJasper.ParametroJasper.push(Formato);
      await this.auxJasper.ParametroJasper.push(banco);

      //---DESCARGA EXCEL
      this.jasperInputExporta$.emit(this.auxJasper);

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.excel = false;
    }
  }

  async exportarDesglose() {
    try {
      let reportes = this.admin_caja.value;

      let selUser = new ParametroJasper();
      let sucursal = new ParametroJasper();
      let cobrosDetallesApertura = new ParametroJasper();
      let cobrosDetallesCierre = new ParametroJasper();
      let usuarioEmite = new ParametroJasper();

      if (this.selectedUsuario !== undefined && this.selectedUsuario !== null) {
        selUser.nombre = '_id_usuario';
        selUser.valor = this.selectedUsuario.value !== null ? this.selectedUsuario.value + "" : null;
      } else {
        selUser.nombre = '_id_usuario';
        selUser.valor = null;
      }
      if (this.selectedSucursal !== undefined && this.selectedSucursal !== null) {
        sucursal.nombre = 'sucursal';
        sucursal.valor = this.selectedSucursal.value !== null ? this.selectedSucursal.value + "" : null;
      } else {
        sucursal.nombre = 'sucursal';
        sucursal.valor = null;
      }
          
      cobrosDetallesApertura.nombre = "_fecha_de";
      cobrosDetallesApertura.valor = reportes.fecha_apertura + "";          
      cobrosDetallesCierre.nombre = "_fecha_hasta";
      cobrosDetallesCierre.valor = reportes.fecha_cierre + "";
      usuarioEmite.nombre = '_usuario';
      usuarioEmite.valor = this.usuario.id + '';

      this.auxJasperDesgloceConceptos = new AuxJasper();
      this.auxJasperDesgloceConceptos.JasperReport.nombreReporte =
        "029_Desgloce_de_conceptos_excel";
      this.auxJasperDesgloceConceptos.JasperReport.tipo = "xlsx";

      await this.auxJasperDesgloceConceptos.ParametroJasper.push(cobrosDetallesApertura);
      await this.auxJasperDesgloceConceptos.ParametroJasper.push(cobrosDetallesCierre);
      await this.auxJasperDesgloceConceptos.ParametroJasper.push(selUser);
      await this.auxJasperDesgloceConceptos.ParametroJasper.push(sucursal);
      await this.auxJasperDesgloceConceptos.ParametroJasper.push(usuarioEmite);

      let emiteJasperDesgloceConceptos = new AuxJasper();
      emiteJasperDesgloceConceptos = this.auxJasperDesgloceConceptos;
      this.jasperInputDesgloceConceptos$.emit(emiteJasperDesgloceConceptos);
      

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.excel = false;
    }
  }
  async imprimeConcentrados() {
    try {
      this.progressBar = true;
      // ESTA ES LA PRIMERA OPCION DE LOS RESPORTES
      //================================================================
      if (
        this.cobrosConcepto == false &&
        this.cobrosAgua == false &&
        this.mediosPago == false &&
        this.detallemMediosPago == false &&
        this.cierraCaja == false &&
        this.cobrosDetalle == false &&
        this.porSucursales == false &&
        this.estadoMovimientos == false &&
        this.conceptosPagados == false
      ) {
        this.cobrosAgua = false;
        this.mediosPago = false;
        this.detallemMediosPago = false;
        this.cobrosConcepto = true;
        this.cierraCaja = false;
        this.cobrosDetalle = false;

        this.porSucursales = false;
        this.estadoMovimientos = false;
        this.conceptosPagados = false;
      }
      //================================================================

      this.buscando = true;
      this.jasperInputExporta$.emit(null);
      let reportes = this.admin_caja.value;

      let cobrosDetallesUsuario = new ParametroJasper();
      let cobrosDetallesApertura = new ParametroJasper();
      let cobrosDetallesCierre = new ParametroJasper();
      let cobrosDetallesSuc = new ParametroJasper();
      let resumenIngresos = new ParametroJasper();
      let selUser = new ParametroJasper();
      let sucursal = new ParametroJasper();
      let usuarioEmite = new ParametroJasper();
      let banco = new ParametroJasper();

      //fragmento de codigo para cuando el usuario no es administrador de caja y solo le genere su propio reporte
      // if (reportes.idUsuarioCajero) {
      //   cobrosDetallesUsuario.nombre = "_id_usuario";
      //   //cobrosDetallesUsuario.valor = this.usuarios.id + '';
      //   if (this.cobros_detalle) {
      //     cobrosDetallesUsuario.valor = null;
      //   } else {
      //     cobrosDetallesUsuario.valor = reportes.idUsuarioCajero + "";
      //   }
      // }
    
   // codigo para generar cualquier reporte de cualquier sucursal
   
if (this.selectedUsuario !== undefined && this.selectedUsuario !== null) {

  selUser.nombre = '_id_usuario';
  selUser.valor = this.selectedUsuario.value !== null ? this.selectedUsuario.value + "" : null;
} else {
  selUser.nombre = '_id_usuario';
  selUser.valor = null;
}
if (this.selectedSucursal !== undefined && this.selectedSucursal !== null) {
  sucursal.nombre = 'sucursal';
  sucursal.valor = this.selectedSucursal.value !== null ? this.selectedSucursal.value + "" : null;
} else {
  sucursal.nombre = 'sucursal';
  sucursal.valor = null;
}
if (this.selectedBank !== undefined && this.selectedBank !== null) {
  banco.nombre = '_id_banco';
  banco.valor = this.selectedBank.value !== null ? this.selectedBank.value + "" : null;
} else {
  banco.nombre = '_id_banco';
  banco.valor = null;
}

    

      cobrosDetallesApertura.nombre = "_fecha_de";
      cobrosDetallesApertura.valor = reportes.fecha_apertura + "";
      cobrosDetallesCierre.nombre = "_fecha_hasta";
      cobrosDetallesCierre.valor = reportes.fecha_cierre + "";
      usuarioEmite.nombre = '_usuario';
      usuarioEmite.valor = this.usuario.id + '';

      if (reportes.idSucursal) {
        cobrosDetallesSuc.nombre = "_id_sucursal";
        if (this.cobros_detalle) {
          cobrosDetallesSuc.valor = null;
        }
        else {
          cobrosDetallesSuc.valor = reportes.idSucursal + "";
        }
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////
      this.auxJasper = new AuxJasper();
      await this.auxJasper.ParametroJasper.push(cobrosDetallesUsuario);
      await this.auxJasper.ParametroJasper.push(cobrosDetallesApertura);
      await this.auxJasper.ParametroJasper.push(cobrosDetallesCierre);
      await this.auxJasper.ParametroJasper.push(cobrosDetallesSuc);
      await this.auxJasper.ParametroJasper.push(resumenIngresos);


      if (this.cobros_detalle) {
        ///////////////////////--- cONCEPTO iva -----////////////////////////////////
        ///////////////////////--- cONCEPTO iva -----////////////////////////////////
        this.auxJasperResumenCuenta = new AuxJasper();
        this.auxJasperResumenCuenta.JasperReport.nombreReporte =
          "013_Concepto_IVA";
        this.auxJasperResumenCuenta.JasperReport.tipo = "pdf";

        await this.auxJasperResumenCuenta.ParametroJasper.push(
          cobrosDetallesApertura
        );
        await this.auxJasperResumenCuenta.ParametroJasper.push(
          cobrosDetallesCierre
        );

        //---EMITE EL REPORTE
        let emiteJasperCuenta = new AuxJasper();
        emiteJasperCuenta = this.auxJasperResumenCuenta;
        //this.jasperInputResumenCuenta$.emit(emiteJasperCuenta);

      }

      else {
        ///////////////////////--- MEDIOS PAGOS -----////////////////////////////////
        ///////////////////////--- MEDIOS PAGOS -----////////////////////////////////
        this.auxJasperTotalesMediosPagos = new AuxJasper();
        this.auxJasperTotalesMediosPagos.JasperReport.nombreReporte =
          "005_MediosPagos";
        this.auxJasperTotalesMediosPagos.JasperReport.tipo = "pdf";

        await this.auxJasperTotalesMediosPagos.ParametroJasper.push(
          cobrosDetallesUsuario
        );
        await this.auxJasperTotalesMediosPagos.ParametroJasper.push(
          cobrosDetallesApertura
        );
        await this.auxJasperTotalesMediosPagos.ParametroJasper.push(
          cobrosDetallesCierre
        );
        await this.auxJasperTotalesMediosPagos.ParametroJasper.push(
          cobrosDetallesSuc
        );
        await this.auxJasperTotalesMediosPagos.ParametroJasper.push(
          resumenIngresos
        );

        //---EMITE EL REPORTE
        let emiteJasper = new AuxJasper();
        //emiteJasper = this.auxJasperTotalesMediosPagos;
        this.jasperInputMediosTotales$.emit(emiteJasper);


        ///////////////////////---detalle medio pago-----////////////////////////////////
        ///////////////////////---detalle medio pago-----////////////////////////////////
        this.auxJasperDetallesMediosPagos = new AuxJasper();
        this.auxJasperDetallesMediosPagos.JasperReport.nombreReporte =
          "006_DetallesMediosPagos";
        this.auxJasperDetallesMediosPagos.JasperReport.tipo = "pdf";

        await this.auxJasperDetallesMediosPagos.ParametroJasper.push(
          cobrosDetallesUsuario
        );
        await this.auxJasperDetallesMediosPagos.ParametroJasper.push(
          cobrosDetallesApertura
        );
        await this.auxJasperDetallesMediosPagos.ParametroJasper.push(
          cobrosDetallesCierre
        );
        await this.auxJasperDetallesMediosPagos.ParametroJasper.push(
          cobrosDetallesSuc
        );
        await this.auxJasperTotalesMediosPagos.ParametroJasper.push(
          resumenIngresos
        );

        //---EMITE EL REPORTE
        let emiteJasperDetalles = new AuxJasper();
        emiteJasperDetalles = this.auxJasperDetallesMediosPagos;
        //this.jasperInputMediosDetalles$.emit(emiteJasperDetalles);


        ///////////////////////---COBROS DETALLES CAJERO-----////////////////////////////////
        ///////////////////////---COBROS DETALLES CAJERO-----////////////////////////////////
        this.auxJasperCobroDetallesCajeros = new AuxJasper();
        this.auxJasperCobroDetallesCajeros.JasperReport.nombreReporte =
          "004_cobrosDetalleCajero";
        this.auxJasperCobroDetallesCajeros.JasperReport.tipo = "pdf";

        await this.auxJasperCobroDetallesCajeros.ParametroJasper.push(
          cobrosDetallesUsuario
        );
        await this.auxJasperCobroDetallesCajeros.ParametroJasper.push(
          cobrosDetallesApertura
        );
        await this.auxJasperCobroDetallesCajeros.ParametroJasper.push(
          cobrosDetallesCierre
        );
        await this.auxJasperCobroDetallesCajeros.ParametroJasper.push(
          cobrosDetallesSuc
        );
        await this.auxJasperTotalesMediosPagos.ParametroJasper.push(
          resumenIngresos
        );

        let emiteJasperCobroDetalleCajero = new AuxJasper();
        emiteJasperCobroDetalleCajero = this.auxJasperCobroDetallesCajeros;
        //this.jasperInputCobroDetalleCajero$.emit(emiteJasperCobroDetalleCajero);


        ///////////////////////--- CIERRE CAJA -----////////////////////////////////
        ///////////////////////--- CIERRE CAJA -----////////////////////////////////
        this.auxJasperCierreCaja = new AuxJasper();
        this.auxJasperCierreCaja.JasperReport.nombreReporte = "005_CierreCaja";
        this.auxJasperCierreCaja.JasperReport.tipo = "pdf";

        await this.auxJasperCierreCaja.ParametroJasper.push(
          cobrosDetallesUsuario
        );
        await this.auxJasperCierreCaja.ParametroJasper.push(
          cobrosDetallesApertura
        );
        await this.auxJasperCierreCaja.ParametroJasper.push(cobrosDetallesCierre);
        await this.auxJasperCierreCaja.ParametroJasper.push(cobrosDetallesSuc);
        ///////////////////////////////////////////////////////////////////////////////////////////////////

        let emiteJasperCierreCaja = new AuxJasper();
        emiteJasperCierreCaja = this.auxJasperCierreCaja;
        //this.jasperInputCierreCaja$.emit(emiteJasperCierreCaja);


        ///////////////////////-- -RESUMEN DE INGRESOS -----////////////////////////////////
        ///////////////////////-- -RESUMEN DE INGRESOS -----////////////////////////////////
        this.auxJasperResumenIngresos = new AuxJasper();
        this.auxJasperResumenIngresos.JasperReport.nombreReporte =
          "011_Detalle_General";
        this.auxJasperResumenIngresos.JasperReport.tipo = "pdf";

        await this.auxJasper.ParametroJasper.push(resumenIngresos);

        await this.auxJasperResumenIngresos.ParametroJasper.push(
          cobrosDetallesUsuario
        );
        await this.auxJasperResumenIngresos.ParametroJasper.push(
          cobrosDetallesApertura
        );
        await this.auxJasperResumenIngresos.ParametroJasper.push(
          cobrosDetallesCierre
        );
        await this.auxJasperResumenIngresos.ParametroJasper.push(
          cobrosDetallesSuc
        );
        await this.auxJasperResumenIngresos.ParametroJasper.push(
          resumenIngresos
        );

        let emiteJasperResumenIngresos = new AuxJasper();
        emiteJasperResumenIngresos = this.auxJasperResumenIngresos;
        //this.jasperInputResumenIngresos$.emit(emiteJasperResumenIngresos);



        ///////////////////////////////////////////////////////////////////////////////////////////////////
        ///////////////////////-- -RESUMEN Por concepto Cuenta-----////////////////////////////////
        this.auxJasperResumenCuenta = new AuxJasper();
        this.auxJasperResumenCuenta.JasperReport.nombreReporte =
          "012_ReportePorConceptosCuenta";
        this.auxJasperResumenCuenta.JasperReport.tipo = "pdf";

        await this.auxJasper.ParametroJasper.push(resumenIngresos);

        await this.auxJasperResumenCuenta.ParametroJasper.push(
          cobrosDetallesUsuario
        );
        await this.auxJasperResumenCuenta.ParametroJasper.push(
          cobrosDetallesApertura
        );
        await this.auxJasperResumenCuenta.ParametroJasper.push(
          cobrosDetallesCierre
        );
        await this.auxJasperResumenCuenta.ParametroJasper.push(
          cobrosDetallesSuc
        );
        await this.auxJasperResumenCuenta.ParametroJasper.push(
          resumenIngresos
        );

        let emiteJasperResumenCuenta = new AuxJasper();
        emiteJasperResumenCuenta = this.auxJasperResumenCuenta;
        //this.jasperInputResumenCuenta$.emit(emiteJasperResumenCuenta);


        ///////////////////////-- -Por concepto -----////////////////////////////////
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "004_ReportePorConceptos";
        this.auxJasper.JasperReport.tipo = "pdf";

        await this.auxJasper.ParametroJasper.push(cobrosDetallesUsuario);
        await this.auxJasper.ParametroJasper.push(cobrosDetallesApertura);
        await this.auxJasper.ParametroJasper.push(cobrosDetallesCierre);
        await this.auxJasper.ParametroJasper.push(cobrosDetallesSuc);
        await this.auxJasper.ParametroJasper.push(resumenIngresos);

        //---EMITE EL REPORTE
        let emiteJasperConcepto = new AuxJasper();
        emiteJasperConcepto = this.auxJasper;
        //this.jasperInput$.emit(emiteJasperConcepto);

      }
      ///////////////////////---COBROS DETALLES -----////////////////////////////////
      this.auxJasperCobrosDetalles = new AuxJasper();
      this.auxJasperCobrosDetalles.JasperReport.nombreReporte =
        "004_cobrosDetalles";
      this.auxJasperCobrosDetalles.JasperReport.tipo = "pdf";

      await this.auxJasperCobrosDetalles.ParametroJasper.push(cobrosDetallesUsuario);
      await this.auxJasperCobrosDetalles.ParametroJasper.push(cobrosDetallesApertura);
      await this.auxJasperCobrosDetalles.ParametroJasper.push(cobrosDetallesCierre);
      await this.auxJasperCobrosDetalles.ParametroJasper.push(cobrosDetallesSuc);
      await this.auxJasperCobrosDetalles.ParametroJasper.push(resumenIngresos);
      await this.auxJasperCobrosDetalles.ParametroJasper.push();

      let emiteJasperCobroDetalles = new AuxJasper();
      emiteJasperCobroDetalles = this.auxJasperCobrosDetalles;
      //this.jasperInputCobrosDetalles$.emit(emiteJasperCobroDetalles);

       ///////////////////////--- POR SUCURSALES -----////////////////////////////////

       let Sucursal  = new ParametroJasper();
       let Usuario = new ParametroJasper();
       this.auxJasperPorSucursales = new AuxJasper();
       this.auxJasperPorSucursales.JasperReport.nombreReporte =
         "ResumenPorSucursal";
       this.auxJasperPorSucursales.JasperReport.tipo = "pdf";

 
       await this.auxJasperPorSucursales.ParametroJasper.push(cobrosDetallesUsuario);
       await this.auxJasperPorSucursales.ParametroJasper.push(cobrosDetallesApertura);
       await this.auxJasperPorSucursales.ParametroJasper.push(cobrosDetallesCierre);
       await this.auxJasperPorSucursales.ParametroJasper.push(cobrosDetallesSuc);
       await this.auxJasperPorSucursales.ParametroJasper.push(resumenIngresos);
       await this.auxJasperPorSucursales.ParametroJasper.push(selUser);
       await this.auxJasperPorSucursales.ParametroJasper.push(sucursal);
       await this.auxJasperPorSucursales.ParametroJasper.push(banco);
       
 
       let emiteJasperPorSucursales = new AuxJasper();
       emiteJasperPorSucursales = this.auxJasperPorSucursales;
       this.jasperInputPorSucursales$.emit(emiteJasperPorSucursales);


        ///////////////////////---ESTADO MOVIMIENTOS -----////////////////////////////////
      this.auxJasperEstadoMovimientos = new AuxJasper();
      this.auxJasperEstadoMovimientos.JasperReport.nombreReporte =
        "EstadoMovimientos";
      this.auxJasperEstadoMovimientos.JasperReport.tipo = "pdf";

      await this.auxJasperEstadoMovimientos.ParametroJasper.push(cobrosDetallesUsuario);
      await this.auxJasperEstadoMovimientos.ParametroJasper.push(cobrosDetallesApertura);
      await this.auxJasperEstadoMovimientos.ParametroJasper.push(cobrosDetallesCierre);
      await this.auxJasperEstadoMovimientos.ParametroJasper.push(cobrosDetallesSuc);
      await this.auxJasperEstadoMovimientos.ParametroJasper.push(resumenIngresos);
      await this.auxJasperEstadoMovimientos.ParametroJasper.push(selUser);
      await this.auxJasperEstadoMovimientos.ParametroJasper.push(sucursal);

      let emiteJasperEstadoMovimientos = new AuxJasper();
      emiteJasperEstadoMovimientos = this.auxJasperEstadoMovimientos;
      this.jasperInputEstadoMovimientos$.emit(emiteJasperEstadoMovimientos);


      ///////////////////////--- Conceptos Pagados -----////////////////////////////////
      this.auxJasperConceptosPagados = new AuxJasper();
      this.auxJasperConceptosPagados.JasperReport.nombreReporte =
        "018_Conceptos_Pagados";
      this.auxJasperConceptosPagados.JasperReport.tipo = "pdf";

      await this.auxJasperConceptosPagados.ParametroJasper.push(cobrosDetallesApertura);
      await this.auxJasperConceptosPagados.ParametroJasper.push(cobrosDetallesCierre);
      await this.auxJasperConceptosPagados.ParametroJasper.push(selUser);
      await this.auxJasperConceptosPagados.ParametroJasper.push(sucursal);

      let emiteJasperConceptosPagados = new AuxJasper();
      emiteJasperConceptosPagados = this.auxJasperConceptosPagados;
      this.jasperInputConceptosPagados$.emit(emiteJasperConceptosPagados);


      ///////////////////////--- Conceptos Pagados -----////////////////////////////////
      this.auxJasperDesgloceConceptos = new AuxJasper();
      this.auxJasperDesgloceConceptos.JasperReport.nombreReporte =
        "029_Desgloce_de_conceptos";
      this.auxJasperDesgloceConceptos.JasperReport.tipo = "pdf";

      await this.auxJasperDesgloceConceptos.ParametroJasper.push(cobrosDetallesApertura);
      await this.auxJasperDesgloceConceptos.ParametroJasper.push(cobrosDetallesCierre);
      await this.auxJasperDesgloceConceptos.ParametroJasper.push(selUser);
      await this.auxJasperDesgloceConceptos.ParametroJasper.push(sucursal);
      await this.auxJasperDesgloceConceptos.ParametroJasper.push(usuarioEmite);

      let emiteJasperDesgloceConceptos = new AuxJasper();
      emiteJasperDesgloceConceptos = this.auxJasperDesgloceConceptos;
      this.jasperInputDesgloceConceptos$.emit(emiteJasperDesgloceConceptos);

       ///////////////////////--- Pagos Cancelados -----////////////////////////////////
       this.auxJasperPagosCancelados = new AuxJasper();
       this.auxJasperPagosCancelados.JasperReport.nombreReporte =
         "033_pagos_cancelados";
       this.auxJasperPagosCancelados.JasperReport.tipo = "pdf";
 
       await this.auxJasperPagosCancelados.ParametroJasper.push(cobrosDetallesApertura);
       await this.auxJasperPagosCancelados.ParametroJasper.push(cobrosDetallesCierre);
       await this.auxJasperPagosCancelados.ParametroJasper.push(selUser);
       await this.auxJasperPagosCancelados.ParametroJasper.push(sucursal);
       await this.auxJasperPagosCancelados.ParametroJasper.push(usuarioEmite);
 
       let emiteJasperPagosCancelados = new AuxJasper();
       emiteJasperPagosCancelados = this.auxJasperPagosCancelados;
       this.jasperInputPagosCancelados$.emit(emiteJasperPagosCancelados);

        ///////////////////////--- Global Detallado -----////////////////////////////////
        this.auxJasperGlobalDetallado = new AuxJasper();
        this.auxJasperGlobalDetallado.JasperReport.nombreReporte =
          "047_Reporte_Global_Ingresos";
        this.auxJasperGlobalDetallado.JasperReport.tipo = "pdf";
  
        await this.auxJasperGlobalDetallado.ParametroJasper.push(cobrosDetallesApertura);
        await this.auxJasperGlobalDetallado.ParametroJasper.push(cobrosDetallesCierre);
        await this.auxJasperGlobalDetallado.ParametroJasper.push(selUser);
        await this.auxJasperGlobalDetallado.ParametroJasper.push(sucursal);
        await this.auxJasperGlobalDetallado.ParametroJasper.push(usuarioEmite);
  
        let emiteJasperGlobalDetallado = new AuxJasper();
        emiteJasperGlobalDetallado = this.auxJasperGlobalDetallado;
        this.jasperInputGlobalDetallado$.emit(emiteJasperGlobalDetallado);
 

    } catch (e) {
    } finally {
      this.buscando = false;
      this.progressBar = false;
    }
    this.getCorteTotal();
  }

//seleccion de sucursal y usuario para la generacion del reporte
onOptionsSelected(event: any) {
  const selectedValue = event.value;
  if (selectedValue === null || selectedValue === undefined) {
    this.selectedSucursal = { label: "Todas", value: null };
  } else {
    this.selectedSucursal = this.catSucursales.find(sucursal => sucursal.value === selectedValue);
    this.selectedBank = {label: "Todos", value: null};
  }
  this.admin_caja.patchValue({ idSucursal: this.selectedSucursal.value });
  this.admin_caja.get('idBanco')?.reset();
}

onSelectUser(event: any) {
  const selectUser = event.value;
  if (selectUser === null || selectUser === undefined) {
    this.selectedUsuario = { label: "Todos", value: null };
  } else {
    this.selectedUsuario = this.catUsuarios.find(datos => datos.value === selectUser);
  }
  this.admin_caja.patchValue({ idUsuarioCajero: this.selectedUsuario.value });
}

onSelectBank(event: any){
  const selectedvalue = event.value;
  if(selectedvalue === null || selectedvalue === undefined){
    this.selectedBank = {label: "Todos", value: null};
  }else{
    this.selectedBank = this.catBancos.find(banco => banco.value === selectedvalue);
    this.selectedSucursal = { label: "Todas", value: null };
  }
  this.admin_caja.patchValue({idBanco: this.selectedBank.value})
  this.admin_caja.get('idSucursal')?.reset();
}
  

getCorteTotal() {
  this.filters = {
    fecha_apertura: this.admin_caja.get('fecha_apertura')?.value,
    fecha_cierre: this.admin_caja.get('fecha_cierre')?.value,
    idUsuarioCajero: this.selectedUsuario?.value,
    idSucursal: this.selectedSucursal?.value
  };

  this.corteTotalService.getByFilters(this.filters).subscribe(
    data => {
    },
    error => {
      console.error('Error in service:', error);
    }
  );
}


async getSucursal(id) {
  try {
    if (id == null) {
    } else {
      if (this.admin_caja.value.idUsuarioCajero) {
        this.usuarioSimple = await this.catUsuariosS
          .getSingle(this.admin_caja.value.idUsuarioCajero)
          .toPromise();

        let datoRetorno = await this.catSucursalService
          .getSingle(this.usuarioSimple.idSucursal)
          .toPromise();

        // Fragmento de código para mostrar todas las sucursales
        // console.log("Datos completos de la sucursal: ", datoRetorno);

        this.catSucursal = datoRetorno;

        let todasSucursales = await this.catSucursalService
          .getAll()
          .toPromise();

        this.catSucursales = todasSucursales.map(sucursal => ({
          label: sucursal.descripcion,
          value: sucursal.id,
        }));

        this.catSucursalActual = [this.catSucursal];

        await this.admin_caja.patchValue({
          idSucursal: this.catSucursal.id,
        });
      } else {
        this.catSucursal = null;
        await this.admin_caja.patchValue({
          idSucursal: null,
        });
      }

      this.catSucursales.unshift({ label: 'Todas', value: null }); 
    }
  } catch (e) {
    if (e.response) throw { message: e.response.data };
    else throw e;
  } finally {
    console.log("Paso por getCatSucursal");
  }
}

async getCatBancos(){
  try{
    this.progressBar = true;

    let datoRetorno = await this.catBancosService.getAll().toPromise();

    this.catBancos = datoRetorno.map((banco) => {
      return { label: banco.descripcion, value: banco.id};
    })

    this.catBancos.unshift({ label: 'Todos', value: null});

  }catch(e){
    if (e.response) throw { message: e.response.data};
    else throw e;

  }finally{
    console.log('Paso por getCatBancos');
    this.progressBar = false;
  }
}

  //====>>>>>>> SE CAMBIA DE TAB
  handleChange(e) {
    var index = e.index;

    switch (index) {
      case 0:
        this.cobrosAgua = false;
        this.mediosPago = false;
        this.detallemMediosPago = false;
        this.cobrosConcepto = true;
        this.cierraCaja = false;
        this.cobrosDetalle = false;
        this.resumenMovimeintos = false;
        this.porSucursales = true;
        this.estadoMovimientos = false;
        this.conceptosPagados = false;
        this.pagosCancelados = false;
        this.globalDetallado = false;
        break;
      case 1:
        this.cobrosAgua = false;
        this.mediosPago = false;
        this.detallemMediosPago = false;
        this.cobrosConcepto = false;
        this.cierraCaja = false;
        this.cobrosDetalle = true;
        this.resumenMovimeintos = false;
        this.conceptoIVA = true;
        this.porSucursales = false;
        this.estadoMovimientos = true;
        this.conceptosPagados = false;
        this.pagosCancelados = false;
        this.globalDetallado = false;
        break;
      case 2:
        this.cobrosAgua = false;
        this.mediosPago = true;
        this.detallemMediosPago = false;
        this.cobrosConcepto = false;
        this.cierraCaja = false;
        this.cobrosDetalle = false;
        this.resumenMovimeintos = false;
        this.porSucursales = false;
        this.estadoMovimientos = false;
        this.conceptosPagados = false;
        this.pagosCancelados = false;
        this.globalDetallado = false;
        break;
      case 3:
        this.cobrosAgua = false;
        this.mediosPago = false;
        this.detallemMediosPago = true;
        this.cobrosConcepto = false;
        this.cierraCaja = false;
        this.cobrosDetalle = false;
        this.resumenMovimeintos = false;
        this.porSucursales = false;
        this.estadoMovimientos = false;
        this.conceptosPagados = true;
        this.pagosCancelados = false;
        this.globalDetallado = false;
        break;
      case 4:
        this.cobrosAgua = true;
        this.mediosPago = false;
        this.detallemMediosPago = false;
        this.cobrosConcepto = false;
        this.cierraCaja = false;
        this.cobrosDetalle = false;
        this.resumenMovimeintos = false;
        this.porSucursales = false;
        this.estadoMovimientos = false;
        this.conceptosPagados = false;
        this.pagosCancelados = false;
        this.globalDetallado = false;
        break;
      case 5:
        this.cobrosAgua = false;
        this.mediosPago = false;
        this.detallemMediosPago = false;
        this.cobrosConcepto = false;
        this.cierraCaja = true;
        this.cobrosDetalle = false;
        this.resumenMovimeintos = false;
        this.porSucursales = false;
        this.estadoMovimientos = false;
        this.conceptosPagados = false;
        this.pagosCancelados = true;
        this.globalDetallado = false;
        break;
      case 6:
        this.cobrosAgua = false;
        this.mediosPago = false;
        this.detallemMediosPago = false;
        this.cobrosConcepto = false;
        this.cierraCaja = false;
        this.cobrosDetalle = false;
        this.resumenMovimeintos = false;
        this.porSucursales = true;
        this.estadoMovimientos = false;
        this.conceptosPagados = false;
        this.pagosCancelados = false;
        this.globalDetallado = false;
        break;
        case 7:
        this.cobrosAgua = false;
        this.mediosPago = false;
        this.detallemMediosPago = false;
        this.cobrosConcepto = false;
        this.cierraCaja = false;
        this.cobrosDetalle = false;
        this.resumenMovimeintos = false;
        this.porSucursales = false;
        this.estadoMovimientos = true;
        this.conceptosPagados = false;
        this.pagosCancelados = false;
        this.globalDetallado = true;
        break;
        case 8:
        this.cobrosAgua = false;
        this.mediosPago = false;
        this.detallemMediosPago = false;
        this.cobrosConcepto = false;
        this.cierraCaja = false;
        this.cobrosDetalle = false;
        this.resumenMovimeintos = false;
        this.porSucursales = false;
        this.estadoMovimientos = false;
        this.conceptosPagados = true;
        this.pagosCancelados = false;
        this.globalDetallado = false;
        break;
      default:
        this.cobrosAgua = true;
        this.mediosPago = false;
        this.detallemMediosPago = false;
        this.cobrosConcepto = false;
        this.cierraCaja = false;
        this.cobrosDetalle = false;
        this.conceptoIVA = false;
        this.porSucursales = true;
        this.estadoMovimientos = false;
        this.conceptosPagados = false;
        this.pagosCancelados = false;
        this.globalDetallado = false;
        break;
    }
  }


  async getPrivilegios() {
    try {
      this.progressBar = true;
      let objUrl = new Privilegios();
      objUrl.descripcion = this.router.url + '/remesa';
      let conPrivilegio = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
      this.privilegiosDrops = conPrivilegio ? false : true; 

      // en caso de no contar con este privilegio, en los drops solo te carga el usuario logeado asi como su sucursal 
      if(this.privilegiosDrops)
      {
        //this.admin_caja.value.idUsuarioCajero = this.catUsuarios.find(x => x.id == this.usuario);
        const now = new Date();
        const fechaActual = now.toISOString().slice(0, 10); // Obtiene el formato "YYYY-MM-DD"
        
        this.fecha = fechaActual;

        this.selectedUsuario = this.catUsuarios.find(x => x.value == this.usuario?.id);
        await this.getSucursal(this.usuarios?.idSucursal);
        this.selectedSucursal = this.catSucursales.find(x => x.value == this.usuario?.idSucursal);
        
        this.admin_caja.patchValue({
          fecha_apertura: fechaActual,
          fecha_cierre: fechaActual,
          idUsuarioCajero:  this.usuario?.id
        });
        
      }



    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPrivilegios");
      this.progressBar = false;
    }
  }
}

